import { useEffect } from "react";
import axios from "axios";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import HowItWorks from "@/components/HowItWorks";
import Services from "@/components/Services";
import PrivateClientsSection from "@/components/PrivateClientsSection";
import Benefits from "@/components/Benefits";
import FAQ from "@/components/FAQ";
import EuFundSection from "@/components/EuFundSection";
import AboutUs from "@/components/AboutUs";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

export default function HomePage() {
  useEffect(() => {
    // Seed initial data on first load
    const seedData = async () => {
      if (!BACKEND_URL) return;
      try {
        await axios.post(`${API}/seed`);
      } catch (e) {
        console.log("Seed data already exists or error:", e.message);
      }
    };
    seedData();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <HeroSection />
        <HowItWorks />
        <Services />
        <PrivateClientsSection />
        <Benefits />
        <FAQ />
        <EuFundSection />
        <AboutUs />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
